import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Input,
  Spinner,
} from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';

interface NewQuestionDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (question: { heading: string; text: string }) => void;
  loading: boolean;
}

const NewQuestionDialog: React.FC<NewQuestionDialogProps> = ({
  isOpen,
  onClose,
  onSave,
  loading,
}) => {
  const [heading, setHeading] = useState('');
  const [text, setText] = useState('');

  const handleSave = () => {
    if (heading.trim() && text.trim()) {
      onSave({ heading: heading.trim(), text: text.trim() });
      setHeading('');
      setText('');
    }
  };

  if (loading) {
    return (
      <Dialog open={isOpen}>
        <DialogSurface>
          <DialogBody>
            <div className="flex items-center justify-center p-8">
              <Spinner size="large" />
            </div>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    );
  }

  return (
    <Dialog modalType='alert' open={isOpen} onOpenChange={(_, data) => !data.open && onClose()}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <Button
                appearance="subtle"
                icon={<DismissRegular />}
                onClick={onClose}
              />
            }
          >
            Skapa ny fråga i underlag
          </DialogTitle>
          <DialogContent className="min-h-[300px] min-w-[500px]">
            <div className="space-y-4">
              <div>
                <h5 className="text-sm font-semibold mb-2">Rubrik:</h5>
                <Input
                  className="w-full"
                  value={heading}
                  onChange={(e) => setHeading(e.target.value)}
                />
              </div>
              <div>
                <h5 className="text-sm font-semibold mb-2">Text:</h5>
                <Input
                  className="w-full"
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button appearance="primary" onClick={handleSave} disabled={!heading.trim() || !text.trim()}>
              SKAPA
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default NewQuestionDialog;
